import React, { createContext } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

const DarkModeContext = createContext();

function DarkModeContextProvider(props) {
  const [darkMode, setDarkMode] = useLocalStorage("dark_mode", false);
  const switchDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div>
      <DarkModeContext.Provider value={{ darkMode, switchDarkMode }}>
        {props.children}
      </DarkModeContext.Provider>
    </div>
  );
}

export { DarkModeContext, DarkModeContextProvider };
